/**
 * TreeMapSwimLaneBackground Component
 *
 * Renders a visual background spanning the full width of a swim lane.
 * Provides visual grouping for related nodes across all columns.
 */

import React from 'react';
import type { SwimLane } from '../../organisms/TreeMap/useTreeMapLayout';

export interface TreeMapSwimLaneBackgroundProps {
  swimLane: SwimLane;
  totalColumns: number;
}

const TreeMapSwimLaneBackground: React.FC<TreeMapSwimLaneBackgroundProps> = ({
  swimLane,
  totalColumns,
}) => {
  // Alternate colors for visual separation
  const index = Number.parseInt(swimLane.id.split('-')[0], 16) || 0;
  const colorClass = index % 2 === 0 ? 'tree-map-swimlane-background--even' : 'tree-map-swimlane-background--odd';

  return (
    <div
      className={`tree-map-swimlane-background ${colorClass}`}
      style={{
        gridColumn: `2 / span ${totalColumns}`, // Span all data columns (skip lane label column)
        gridRow: `${swimLane.rowStart} / span ${swimLane.rowSpan}`,
      }}
    />
  );
};

export default TreeMapSwimLaneBackground;
